import { useCallback, useEffect, useState } from "react";
import { LogOut } from "lucide-react";
import { Header } from "@/components/Header";
import { PinLogin } from "@/components/PinLogin";
import { GestureLogin } from "@/components/GestureLogin";
import { Gallery } from "@/components/Gallery";
import { AssetManager } from "@/components/AssetManager";
import { useEvent } from "@/context/EventContext";
import { api, adminHeaders, getAdminToken, setAdminToken } from "@/lib/api";

export default function AdminPage() {
  const { event } = useEvent();
  const [authed, setAuthed] = useState(null);
  const [gestureOk, setGestureOk] = useState(false);
  const [tab, setTab] = useState("gallery");

  useEffect(() => {
    if (!getAdminToken()) return setAuthed(false);
    api.get("/admin/me", { headers: adminHeaders() }).then(() => setAuthed(true)).catch(() => {
      setAdminToken("");
      setAuthed(false);
    });
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/admin/logout", null, { headers: adminHeaders() });
    } catch (e) {
      console.warn("logout request failed", e);
    }
    setAdminToken("");
    setAuthed(false);
  }, []);

  const unauthorized = useCallback(() => {
    setAdminToken("");
    setAuthed(false);
  }, []);

  const gestureMode = event?.login_mode === "gesture" && !gestureOk;

  return (
    <div className="app-bg grain flex min-h-screen flex-col">
      <Header right={authed ? <button onClick={logout} className="btn btn-ghost btn-icon" aria-label="Çıkış" data-testid="admin-logout-button"><LogOut size={16} /></button> : null} />
      <main className="relative z-10 mx-auto w-full max-w-4xl flex-1 px-4 py-8 sm:px-6" data-testid="admin-page">
        {authed === false && (
          <div className="flex justify-center pt-8">
            {gestureMode ? <GestureLogin onSuccess={() => setGestureOk(true)} /> : <PinLogin onSuccess={() => setAuthed(true)} />}
          </div>
        )}
        {authed && (
          <>
            <div className="mb-8 inline-flex rounded-full border border-white/10 bg-white/5 p-1" data-testid="admin-tabs">
              {[
                ["gallery", "Galeri"],
                ["assets", "Varlıklar"],
              ].map(([k, label]) => (
                <button key={k} onClick={() => setTab(k)} className={`rounded-full px-4 py-1.5 text-xs font-bold transition-colors ${tab === k ? "bg-[var(--accent)] text-white" : "text-slate-300"}`} data-testid={`admin-tab-${k}`}>
                  {label}
                </button>
              ))}
            </div>
            {tab === "gallery" ? <Gallery onUnauthorized={unauthorized} /> : <AssetManager onUnauthorized={unauthorized} />}
          </>
        )}
      </main>
    </div>
  );
}
